module.exports = __webpack_public_path__ + "static/media/normal-theme-selected-mode-icon.78f7164d.svg";